import { render, staticRenderFns } from "./UploadContent.vue?vue&type=template&id=7993989d&scoped=true"
import script from "./UploadContent.vue?vue&type=script&lang=js"
export * from "./UploadContent.vue?vue&type=script&lang=js"
import style0 from "./UploadContent.vue?vue&type=style&index=0&id=7993989d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7993989d",
  null
  
)

export default component.exports